import EventEmitter from 'events'
import store from '@/store'

class AuthService extends EventEmitter {
  async isAuthenticated() {
    if (store.state['Auth'].user != null) {
      return true
    } 
    return await store.dispatch('Auth/fetchUser')
  }
}

export default new AuthService()
